@import "../config/_helpers";
.message-card-section {
	.message-card-options {
		.message-card-option {
			border: 2px solid rgba(0, 0, 0, 0.1);
			border-radius: 5px;
			margin-bottom: 10px;
			display: flex;
			align-items: stretch;
			justify-content: space-between;
			transition: 0.2s all ease-in-out;
			cursor: pointer;
			flex-wrap: wrap;
			.message-check {
				flex: 0 0 100px;
				background: rgba(0, 0, 0, 0.1);
				display: flex;
				align-content: center;
				justify-content: center;
				flex-wrap: wrap;
				@include at-breakpoint(0, $l) {
					flex: 0 0 70px;
				}
				.checkmark {
					aspect-ratio: 1/1;
					width: 30px;
					display: flex;
					align-items: center;
					justify-content: center;
					font-size: large;
					border-radius: 50%;
					height: 30px;
					background: rgba(0, 0, 0, 0.2);
					color: transparent;
					border: 2px solid rgba(0, 0, 0, 0.2);
					transition: 0.2s all ease-in-out;
				}
				strong {
					flex: 0 0 100%;
					text-align: center;
					margin-top: 10px;
				}
			}
			.message-card-option-text {
				padding: 20px;
				flex: 1;
				strong {
					border-bottom: 1px solid rgba(0, 0, 0, 0.1);
					margin-bottom: 10px;
					padding-bottom: 5px;
				}
				@include at-breakpoint(0, $l) {
					padding: 10px;
				}
			}

			&.active {
				border-color: var(--emphasis-color);
				.message-check {
					background: var(--emphasis-color-light-6);
					.checkmark {
						background: var(--emphasis-color);
						color: white;
						border-color: var(--emphasis-color-dark-2);
					}
				}
			}

			.personalised-card-choice {
				width: 100%;
				padding: 20px;
				background: rgba(0, 0, 0, 0.05);
				border-radius: 5px;
				.card-bg {
					position: relative;
					flex: 0 0 100%;
				}
				.text-content {
					position: relative;
					strong.personalised-card-title {
						margin-bottom: 10px;
						flex: 0 0 100%;
						display: flex;
						justify-content: space-between;
						font-size: 16px;

						@include at-breakpoint(0, $m) {
							flex-direction: column;
							gap: 10px;
							align-items: flex-start;
						}

						.delivery-deadline {
							display: flex;
							align-items: center;
							gap: 5px;
							color: #A9252F;
							font-size: 14px;

							svg {
								font-size: 12px;
							}
						}
					}
				}
				.personalised-card-cover {
					height: 200px;
					background-repeat: no-repeat;
					background-size: contain;
					background-position: center;
					border-radius: 5px;
					margin: 0 auto;
					margin-top: 20px;
				}
				button {
					margin: 0 auto;
					margin-top: 20px;
					@include at-breakpoint(0, $l) {
						width: 100%;
					}
				}
			}
		}
	}

	
	.also-add {
		margin: 20px 0;
	}
	.free-message-card-choice {
		background: rgba(0, 0, 0, 0.05);
		padding: 20px;
		width: 100%;
		border-radius: 5px;
		.field {
			margin-top: 20px;
			.remaining-characters-section {
				opacity: 0.5;
				position: absolute;
				bottom: 5px;
				right: 5px;
				font-size: smaller;
				user-select: none;
				pointer-events: none;
			}
		}
		.personalised-warning {
			display: flex;
			height: 100%;
			align-items: center;
			flex-direction: column;
			padding: 20px;
			svg {
				font-size: 42px;
				margin-bottom: 10px;
			}
		}
		strong {
			font-size: 16px;
			margin-bottom: 5px;
		}
	}

	.personalised-card-modal-wrapper {
		display: none;
		align-items: center;
		justify-content: center;
		background: rgba(0, 0, 0, 0.5);
		position: fixed;
		inset: 0;
		z-index: 200;
		&.open {
			display: flex;
		}
		iframe.personalised-card-modal {
			position: absolute;
			inset: 50%;
			transform: translate(-50%, -50%);
			border: none;
			width: 90%;
			height: 70%;
			max-height: 800px;
			max-width: 600px;
		}
	}
}
